const isMobile = () => {
  const ua = navigator.userAgent
  return !!ua.match(/AppleWebKit.*Mobile.*/)
}

export default isMobile
